class ComponentCollectionSlider extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      slider: ".collection-slider",
      previous_button: "button:first-of-type",
      next_button: "button:last-of-type"
    });
  }

  connectedCallback() {
    this.observer();
    this.events();
  }

  observer() {
    const observer = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        const width = entry.contentRect.width;

        if (this.slider) {
          this.teardown();
        }

        this.setup(width);
      });
    });

    observer.observe(this);
  }

  setup(width) {
    if (width < 768) return;

    const el = this.elements.slider;
    if (!el) return;

    const w = el.getBoundingClientRect().width;
    if (!w) {
      requestAnimationFrame(() => this.setup(this.getBoundingClientRect().width || 1));
      return;
    }

    let options = {
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      groupCells: 2,
    };

    if (width < 1024) options.dragThreshold = 5;

    this.slider = new Flickity(el, options);

    window.addEventListener('load', () => this.slider.resize(), { once: true });
  }

  teardown() {
    if (this.slider && this.slider.destroy) this.slider.destroy();

    this.slider = null;
  }

  next() {
    this.slider.next();
  }

  previous() {
    this.slider.previous();
  }
}

customElements.define("component-collection-slider", ComponentCollectionSlider);